import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../core/header/core.service';
import { MatDialog } from '@angular/material/dialog';
import { QRCodeOpenComponent } from './qrcode-open.component';

declare let jquery: any;
declare let $: any;

@Component({
    selector: 'convfact-qrcode',
    templateUrl: './qrcode.component.html',
    styleUrls: ['./qrcode.component.css'],
    standalone: false
})
export class QRCodeComponent implements OnInit {

  constructor(public dialog: MatDialog, private coreService: CoreService) { }

  ngOnInit() {
    this.coreService.setName("Código QR");
  }

  openQRScanner(): void {
    this.dialog.open(QRCodeOpenComponent, {
      maxWidth: '90vw',
      maxHeight: '90vh'
      //width: '60%',
      //panelClass: 'full-screen'
    });
  }

}
